<template>
  <section class="bonus-campaign-rules" aria-labelledby="bonus-campaign-rules-heading">
    <h2 id="bonus-campaign-rules-heading" class="bonus-campaign-rules__heading">
      {{ $t(`${messagesPrefix}.rulesHeading`) }}
    </h2>
    <div class="bonus-campaign-rules__row">
      <template v-for="(step, idx) in steps" :key="step.slug">
        <article
          class="bonus-campaign-rules__card"
        >
          <div class="bonus-campaign-rules__icon" aria-hidden="true">
            <img :src="step.iconSrc" alt="" />
          </div>
          <h3 class="bonus-campaign-rules__title">{{ $t(`${messagesPrefix}.rules.${step.slug}.title`) }}</h3>
          <p class="bonus-campaign-rules__desc">
            {{ $t(`${messagesPrefix}.rules.${step.slug}.description`) }}
            <template v-if="step.pointsKey">
              {{ " " }}
              <span class="bonus-campaign-rules__desc-points">{{
                $t(step.pointsKey)
              }}</span>
            </template>
          </p>
        </article>
        <div
          v-if="idx < steps.length - 1"
          class="bonus-campaign-rules__arrow"
          aria-hidden="true"
        ></div>
      </template>
    </div>
  </section>
</template>

<script setup>
import { computed, defineProps } from "vue";
import tyresIcon from "@/assets/img/bonus/tyres.svg";
import flagIcon from "@/assets/img/bonus/flag.svg";
import trophyIcon from "@/assets/img/bonus/trophy.svg";
import giftIcon from "@/assets/img/bonus/gift.svg";

const props = defineProps({
  messagesPrefix: { type: String, required: true },
});

const isUhrdRules = computed(
  () => props.messagesPrefix === "portalHome.bonusUhrdPage"
);

const steps = computed(() => [
  { slug: "passengerTyres", iconSrc: tyresIcon, highlight: false, pointsKey: null },
  {
    slug: "achieveAdv",
    iconSrc: flagIcon,
    highlight: false,
    pointsKey: `${props.messagesPrefix}.rules.achieveAdv.points`,
  },
  {
    slug: "challengeAdv",
    iconSrc: trophyIcon,
    highlight: false,
    pointsKey: isUhrdRules.value
      ? null
      : `${props.messagesPrefix}.rules.challengeAdv.points`,
  },
  { slug: "rewardsHighlighted", iconSrc: giftIcon, highlight: true, pointsKey: null },
]);

</script>

<style scoped lang="scss">
@import "@/styles/portal-home/bonus-campaign-rules-row";
</style>
